import Vuex from 'vuex';
import Vue from 'vue';
import authorization from '@/state/authorization/authorizationModule';
import snackbar from '@/state/snackbarModule';
import createPersistedState from "vuex-persistedstate";
import exchanges from '@/state/exchanges/exchangesModule';
import userData from '@/state/user/userDataModule';
import notifications from "@/state/notifications/notificationsModule";
import notificationPreferences from "@/state/notifications/notificationPreferencesModule";
import publicBotStats from "@/state/public-bot-stats/publicBotStatsModule";
import eventbus from "@/state/eventbus/eventbusModule";
import bots from "@/state/bots/botsModule";
import payments from "@/state/payments/paymentsModule";
import global from "@/state/global/globalModule";
import subscription from "@/state/subscription/subscriptionModule";
import cache from "@/state/cache/cacheModule";
import userPreferences from "@/state/user-preferences/userPreferencesModule";
import shared from "@/state/shared/sharedModule";
import wallet from "@/state/wallet/walletModule";
import holdingTiers from "@/state/holding-tier/obtHoldingTierModule";
import nft from "@/state/nft/nftModule";

Vue.use(Vuex)

/**
 * Constant responsible for building and persisiting the state of the application
 */
const store = new Vuex.Store({
  modules: {
    authorization,
    snackbar,
    exchanges,
    userData,
    notifications,
    notificationPreferences,
    publicBotStats,
    eventbus,
    bots,
    payments,
    global,
    subscription,
    cache,
    userPreferences,
    shared,
    wallet,
    holdingTiers,
    nft
  },
  plugins: [
    createPersistedState(),
  ],
});

export default store